// extracted by mini-css-extract-plugin
module.exports = {"flex":"SubmitButton_flex__V1Qto","spinner":"SubmitButton_spinner__rD5Cd","disabled":"SubmitButton_disabled__7dL9F"};